module.exports = "https://cdn2-fs.clearscore.com/flux/images/b9a12a08222cb19a1904537ce4349969.jpg";